/* eslint-disable max-lines */
import React from "react";
import { TYPE_SP } from "../../common/defines";
import Dropdown from "semantic-ui-react/dist/commonjs/modules/Dropdown";
import Checkbox from "semantic-ui-react/dist/commonjs/modules/Checkbox";
import Input from "semantic-ui-react/dist/commonjs/elements/Input";
import Radio from "semantic-ui-react/dist/commonjs/addons/Radio";

import masterData from "../../lib/masterData";
import { AreaChecker } from "./AreaChecker";
import { ItemSelector } from "./ItemSelector";
import { AssetType } from "./AssetType";
import { Facility } from "./Facility";
import _ from 'lodash';
import { findStation } from "../../lib/masterUtil";
import { area_selector } from "../../common/area_selector";

const toInt = (value) => {
  if (typeof value === "string") {
    return parseInt(value, 10);
  } else {
    return value;
  }
}

export class SearchCondition extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = this.getState(props);
  }
  componentWillReceiveProps(newProps) {
    this.setState(this.getState(newProps));
  }
  getState(props) {
    return { value: Object.assign({}, props.value) };
  }
  radioChange = (e, { value }) => this.onUpdateValue({ targetState: value })
  onUpdateValue(value) {
    let newValue = Object.assign({}, this.state.value);
    /* eslint-disable guard-for-in */
    for (const key in value) {
      if (value[key]) {
        newValue[key] = value[key]
      } else {
        if (key == "keywordTarget") {
          newValue = { keywordTarget: 0 }
          continue;
        }
        delete newValue[key];
      }
    }
    // lineが変更されたとき、該当しないstationを削除する
    if ('line' in value) {
      newValue.station = newValue.station && newValue.station.filter((stationId => {
        for (const lineSlug of value.line || []) {
          const line = masterData.line.bySlug[lineSlug];
          if (!line) {
            console.error('invalid lineSLug', lineSlug)
            continue;
          }
          if (line.stations.includes(stationId)) {
            return true;
          }
        }
        return false;
      }))
    }
    // タイプに変更があったら金額、広さ、階、設備を初期化する
    if ('assetType' in value) {
      newValue.priceFrom = null;
      newValue.priceTo = null;
      newValue.extentFrom = null;
      newValue.extentTo = null;
      newValue.floor = null;
      newValue.facility = null;
    }
    console.log(value, newValue);
    this.setState({ value: newValue });
  }
  onSearch = () => {
    console.log('SearchCondition.onSearch', this.state.value)
    this.setState({ contentVisible: null });
    this.props.onSearch(this.state.value);
  }
  onKeyDown = e => {
    if (e.keyCode === 13) {
      this.onSearch();
    }
  };

  toggleContent(elementName) {
    const contentVisible = new Set(this.state.contentVisible);
    if (contentVisible.has(elementName)) {
      contentVisible.delete(elementName);
    } else {
      contentVisible.add(elementName);
    }
    this.setState({ contentVisible });
  }
  /* eslint-disable complexity */
  render() {
    const params = this.props.match && this.props.match.params;
    const line = params && params.line ? masterData.line.bySlug[params.line] : null;
    const stationId = params && findStation(line, params.station)
    const station = masterData.station.byId[stationId];
    let pref = null;
    if (params && params.pref) {
      pref = masterData.pref.bySlug[params.pref];
    } else if (this.state.value.pref) {
      pref = masterData.pref.byId[this.state.value.pref];
    } else if (station) {
      pref = masterData.pref.byId[station.prefs];
    }
    const cities = pref && masterData.city.byPref[pref.prefId];
    /* eslint-disable no-underscore-dangle */
    const _cities = _.uniqBy(cities, (c) => {
      return c.name;
    })
    const lines = pref && masterData.line.byPref[pref.prefId];
    const stations = _.uniqBy(Array.prototype.concat.apply(
      [],
      (this.state.value.line || []).map(lineSlug =>
        masterData.line.bySlug[lineSlug].stations
          .map(station_id => masterData.station.byId[station_id])
          .filter(item => item && (!pref || item.prefs === pref.prefId))
      )
    ), tempStation => tempStation.stationId);

    const lineCount = {};
    const stationCount = {};
    const cityCount = { all: 0 };
    masterData.asset.list.forEach(asset => {
      if (pref && pref.prefId !== asset.pref) {
        return;
      }
      cityCount.all += 1;
      const city = asset.pref && asset.city && masterData.city.byPrefAndSlug[asset.pref][asset.city];
      if (city) {
        cityCount[city.slug] = (cityCount[city.slug] || 0) + 1;
        if (city.baseSlug) {
          cityCount[city.baseSlug] = (cityCount[city.baseSlug] || 0) + 1;
        }
      }
      const lineFound = {};
      for (const stationInfo of asset.stations || []) {
        const station = stationInfo.station && masterData.station.byId[stationInfo.station];
        if (station) {
          stationCount[station.stationId] = (stationCount[station.stationId] || 0) + 1;
          for (const lineSlug of station.lines || []) {
            if (!lineFound[lineSlug]) {
              lineCount[lineSlug] = (lineCount[lineSlug] || 0) + 1;
              lineFound[lineSlug] = true;
            }
          }
        }
      }
    })

    const isVisible = (type) => this.state.contentVisible && this.state.contentVisible.has(type);

    const getContentVibleIcon = (type) => {
      return "fas " + (isVisible(type) ? "fa-minus" : "fa-plus")
    }

    const options = [
      { key: 0,
text: 'すべて',
value: 0 },
      { key: 1,
text: '住所',
value: 1 },
      { key: 2,
text: '駅名',
value: 2 },
      { key: 3,
text: '物件名',
value: 3 },
    ]

    // タイプ選択によって有効な項目を切り替える
    let setsubiAvailableFlg = true;
    let floorAvailableFlg = true;
    if (this.state.value.assetType && this.state.value.assetType.length) {
      if (this.state.value.assetType.indexOf("okunai") === -1) {
        if (this.state.value.assetType.indexOf("okugai") !== -1) {
          // 「屋外だけ」「屋外＆バイク」の時
          setsubiAvailableFlg = false;
        } else if (this.state.value.assetType.indexOf("bikeonly") !== -1) {
          // 「バイクだけ」の時
          setsubiAvailableFlg = false;
          floorAvailableFlg = false;
        }
      }
    }

    if (this.props.type === TYPE_SP) {
      return (<div>
        {!pref && <div
          className="search_condition"
          style={pref ? { display: "none" } : {}}
        >
          <div className="context" >
            <div className="collection others">
              <div className="label">キーワード</div>
              <div className="collection keyword">
                <Input
                  type="text"
                  style={{ width: "100%" }}
                  placeholder="例）渋谷　"
                  value={this.state.value.keyword}
                  onChange={(event) => {
                    this.onUpdateValue({ keyword: event.target.value });
                  }}
                  onKeyDown={this.onKeyDown}
                  label={<Dropdown
                    value={toInt(this.state.value.keywordTarget)}
                    defaultValue={0}
                    style={{ width: "100px" }}
                    options={options}
                    onChange={(event, element) => {
                      this.onUpdateValue({ keywordTarget: element.value });
                    }}
                  />}
                  labelPosition="left"
                >
                </Input>
              </div>
            </div>
          </div>
        </div>}
        {!pref && <div
          className="search_a"
          style={pref ? { display: "none" } : {}}
        >
          <div className="sp">
            <div className="select_kicker">都道府県を選択</div>
            <div className="title">都道府県を選択してください。</div>
            {area_selector(this.props.type)}
          </div>
          <div className="pc">
            <div className="title">都道府県を選択してください。</div>
            {area_selector(this.props.type)}
          </div>
        </div>}
        {this.props.mode !== 'line' && <div
          className="area_checker"
          style={!pref ? { display: "none" } : {}}
        >
          <div className="sptitle" onClick={() => {
 this.toggleContent('city')
}}>市区町村を選択する
            <div className="btn_plus"><i className={getContentVibleIcon('city')}></i></div>
          </div>
          <div
           style={isVisible('city') ? {} : { display: "none" }}
          >
            <AreaChecker
              pref={pref}
              count={cityCount}
              cities={_cities}
              value={this.state.value.city}
              onChangeValue={value => {
                this.onUpdateValue({ city: value });
              }}
            />
          </div>
        </div>}
        {this.props.mode !== 'area' && lines && lines.length > 0 && <div
          className="area_checker"
        >
          <div className="sptitle" onClick={() => {
 this.toggleContent('line')
}}>路線を選択する
            <div className="btn_plus"><i className={getContentVibleIcon('line')}></i></div>
          </div>
          <div
           style={isVisible('line') ? {} : { display: "none" }}
          >
            <ItemSelector
              pref={pref}
              options={lines}
              count={lineCount}
              value={this.state.value.line}
              idField="slug"
              onChangeValue={value => {
                this.onUpdateValue({ line: value });
              }}
            />
          </div>
        </div>}
        {this.props.mode !== 'area' && stations.length > 0 && <div
          className="area_checker"
        >
          <div className="title">駅を選択してください</div>
          <ItemSelector
            pref={pref}
            options={stations}
            count={stationCount}
            value={this.state.value.station}
            idField="stationId"
            onChangeValue={value => {
              this.onUpdateValue({ station: value });
            }}
          />
        </div>}
        <div className="search_condition" id="searchArea">
          <div className="sptitle" onClick={() => {
 this.toggleContent('more')
}}>さらに絞り込む
            <div className="btn_plus"><i className={getContentVibleIcon('more')}></i></div>
          </div>
          <div
            className="context"
            style={isVisible('more') ? {} : { display: "none" }}
          >
            <div className="label">タイプ</div>
            <AssetType
              value={this.state.value.assetType}
              onChangeValue={value =>
                this.onUpdateValue({ assetType: value })
              }
            />
            <div className="collection others">

              <div className="item">
                <div className="label">金額（月額使用料）</div>
                <Dropdown
                  className="dropdownStyleBlock"
                  value={toInt(this.state.value.priceFrom)}
                  style={{ width: '100px' }}
                  key="0"
                  placeholder="指定なし"
                  options={masterData.priceNew.list}
                  inline
                  onChange={(event, element) => {
                    this.onUpdateValue({ priceFrom: element.value });
                  }}
                />
                円～
                <Dropdown
                  className="dropdownStyleBlock"
                  value={toInt(this.state.value.priceTo)}
                  style={{ width: '100px' }}
                  key="0"
                  placeholder="指定なし"
                  options={masterData.priceNew.list.filter(option =>
                    !this.state.value.priceFrom || option.value > this.state.value.priceFrom || option.value === 0
                  )}
                  inline
                  onChange={(event, element) => {
                    this.onUpdateValue({ priceTo: element.value });
                  }}
                />
                円
              </div>
              <div className="item">
                <div className="label">広さ</div>
                <Dropdown
                  className="dropdownStyleBlock"
                  value={toInt(this.state.value.extentFrom)}
                  style={{ width: '100px' }}
                  key="0"
                  placeholder="指定なし"
                  options={masterData.extentNew.list}
                  inline
                  onChange={(event, element) => {
                    this.onUpdateValue({ extentFrom: element.value });
                  }}
                />
                帖～
                <Dropdown
                  className="dropdownStyleBlock"
                  value={toInt(this.state.value.extentTo)}
                  style={{ width: '100px' }}
                  key="0"
                  placeholder="指定なし"
                  options={masterData.extentNew.list.filter(option =>
                    !this.state.value.extentFrom || option.value > this.state.value.extentFrom || option.value === 0
                  )}
                  inline
                  onChange={(event, element) => {
                    this.onUpdateValue({ extentTo: element.value });
                  }}
                />
                帖
              </div>
              <div className="item">
                <div className="label">階数</div>
                <Dropdown
                  className="dropdownStyleBlock"
                  value={toInt(this.state.value.floor)}
                  style={{ width: '100px' }}
                  key="0"
                  placeholder="指定なし"
                  options={masterData.floorNew.list.filter(option =>
                    floorAvailableFlg || (!floorAvailableFlg && option.value <= 1)
                  )}
                  inline
                  onChange={(event, element) => {
                    this.onUpdateValue({ floor: element.value });
                  }}
                />
              </div>
              <div className="item">
                <div className="label" style={{ paddingBottom: '15px' }}>設備</div>
                <div className="item widthLongButton">
                  <Facility
                    value={this.state.value.facility}
                    margin={{ top: 20 }}
                    onChangeValue={value =>
                      this.onUpdateValue({ facility: value })
                    }
                    setsubiAvailableFlg={setsubiAvailableFlg}
                  />
                </div>
              </div>

            {pref && <div
              style={!pref ? { display: "none" } : {}}
            >
              <div className="label">キーワード</div>
              <div className="collection keyword">
                <Input
                  type="text"
                  style={{ width: "100%" }}
                  placeholder="例）渋谷　"
                  value={this.state.value.keyword}
                  onChange={(event) => {
                    this.onUpdateValue({ keyword: event.target.value });
                  }}
                  onKeyDown={this.onKeyDown}
                  label={<Dropdown
                    value={toInt(this.state.value.keywordTarget)}
                    defaultValue={0}
                    style={{ width: "100px" }}
                    options={options}
                    onChange={(event, element) => {
                      this.onUpdateValue({ keywordTarget: element.value });
                    }}
                  />}
                  labelPosition="left"
                >
                </Input>
              </div>
            </div>}
            </div>
            <div className="context">
              <div className="collection others">
                <div className="collection">
                  <div className="item" style={{ marginRight: "20px" }}>
                    <Radio
                      label="空室のある物件から検索"
                      name="radioGroup"
                      value="0"
                      checked={!this.state.value.targetState || this.state.value.targetState === '0'}
                      onChange={this.radioChange}
                      className="target_kuushitsu"
                      style={{ fontSize: 14 }}
                    />
                  </div>
                  <div className="item" style={{ marginRight: "20px" }}>
                    <Radio
                      label="空き予定のある物件から検索"
                      name="radioGroup"
                      value="1"
                      checked={this.state.value.targetState === '1'}
                      onChange={this.radioChange}
                      className="target_akiyotei"
                      style={{ fontSize: 14 }}
                    />
                  </div>
                  <div className="item" style={{ marginRight: "20px" }}>
                    <Radio
                      label="全ての部屋から検索"
                      name="radioGroup"
                      value="2"
                      checked={this.state.value.targetState === '2'}
                      onChange={this.radioChange}
                      className="target_all"
                      style={{ fontSize: 14 }}
                    />
                  </div>
                </div>
                <div className="item other_checks">
                  <Checkbox
                    checked={this.state.value.campaign}
                    label="キャンペーン中物件から選ぶ"
                    style={{ fontSize: 14 }}
                    onChange={(event, element) => {
                      this.onUpdateValue({ campaign: element.checked });
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="flexed_helper">
            <div
              className="btn"
              onClick={this.onSearch}
              style={ _.isEqual(this.props.value, this.state.value) ? { display: "none" } : {}}
            >
              検索
            </div>
          </div>
        </div>
      </div>)
    } else {
      return (
        <div>
          {!pref && <div
            className="search_condition"
            style={pref ? { display: "none" } : {}}
          >
            <div className="context">
              <div className="label">キーワード</div>
              <div className="collection keyword">
                <Input
                  type="text"
                  style={{ width: "100%" }}
                  placeholder="例）渋谷　"
                  value={this.state.value.keyword}
                  onChange={(event) => {
                    this.onUpdateValue({ keyword: event.target.value });
                  }}
                  onKeyDown={this.onKeyDown}
                  label={<Dropdown
                    value={toInt(this.state.value.keywordTarget)}
                    defaultValue={0}
                    style={{ width: "100px" }}
                    options={options}
                    onChange={(event, element) => {
                      this.onUpdateValue({ keywordTarget: element.value });
                    }}
                  />}
                  labelPosition="left"
                >
                </Input>
              </div>
            </div>
          </div>}
          {!pref && <div
            className="search_a"
            style={pref ? { display: "none" } : {}}
          >
            <div className="sp">
              <div className="select_kicker">都道府県を選択</div>
              <div className="title">都道府県を選択してください。</div>
              {area_selector(this.props.type)}
            </div>
            <div className="pc">
              <div className="title">都道府県を選択してください。</div>
              {area_selector(this.props.type)}
            </div>
          </div>}
          {this.props.mode !== 'line' && <div
            className="area_checker"
            style={!pref ? { display: "none" } : {}}
          >
            <div className="title">市区町村を選択してください。</div>
            <AreaChecker
              pref={pref}
              count={cityCount}
              cities={_cities}
              value={this.state.value.city}
              onChangeValue={value => {
                this.onUpdateValue({ city: value });
              }}
            />
          </div>}
          {this.props.mode !== 'area' && lines && lines.length > 0 && <div
            className="area_checker"
          >
            <div className="title">路線を選択してください</div>
            <ItemSelector
              pref={pref}
              options={lines}
              count={lineCount}
              value={this.state.value.line}
              idField="slug"
              onChangeValue={value => {
                this.onUpdateValue({ line: value });
              }}
            />
          </div>}
          {this.props.mode !== 'area' && stations.length > 0 && <div
            className="area_checker"
          >
            <div className="title">駅を選択してください</div>
            <ItemSelector
              pref={pref}
              options={stations}
              count={stationCount}
              value={this.state.value.station}
              idField="stationId"
              onChangeValue={value => {
                this.onUpdateValue({ station: value });
              }}
            />
          </div>}
          <div className="search_condition" id="searchArea">
            <div className="title">さらに絞り込む</div>
            <div className="context">
              <div className="collection">
                <div className="item" style={{ marginRight: "20px" }}>
                  <Radio
                    label="空室のある物件から検索"
                    name="radioGroup"
                    value="0"
                    checked={!this.state.value.targetState || this.state.value.targetState === '0'}
                    onChange={this.radioChange}
                    className="target_kuushitsu"
                    style={{ fontSize: 14 }}
                  />
                </div>
                <div className="item" style={{ marginRight: "20px" }}>
                  <Radio
                    label="空き予定のある物件から検索"
                    name="radioGroup"
                    value="1"
                    checked={this.state.value.targetState === '1'}
                    onChange={this.radioChange}
                    className="target_akiyotei"
                    style={{ fontSize: 14 }}
                  />
                </div>
                <div className="item" style={{ marginRight: "20px" }}>
                  <Radio
                    label="全ての部屋から検索"
                    name="radioGroup"
                    value="2"
                    checked={this.state.value.targetState === '2'}
                    onChange={this.radioChange}
                    className="target_all"
                    style={{ fontSize: 14 }}
                  />
                </div>
              </div>
              <div className="collection">
                <div className="item">
                  <Checkbox
                    checked={this.state.value.campaign}
                    label="キャンペーン中物件から選ぶ"
                    style={{ fontSize: 14 }}
                    onChange={(event, element) => {
                      this.onUpdateValue({ campaign: element.checked });
                    }}
                  />
                </div>
              </div>
              <div className="collection">
                <div className="item">
                <div className="label">タイプ</div>
                  <AssetType
                    value={this.state.value.assetType}
                    onChangeValue={value =>
                      this.onUpdateValue({ assetType: value })
                    }
                  />
                </div>
              </div>
            {pref && <div
              style={!pref ? { display: "none" } : {}}
            >
              <div className="label">キーワード</div>
              <div className="collection keyword">
                <Input
                  type="text"
                  style={{ width: "100%" }}
                  placeholder="例）渋谷　"
                  value={this.state.value.keyword}
                  onChange={(event) => {
                    this.onUpdateValue({ keyword: event.target.value });
                  }}
                  onKeyDown={this.onKeyDown}
                  label={<Dropdown
                    value={toInt(this.state.value.keywordTarget)}
                    defaultValue={0}
                    style={{ width: "100px" }}
                    options={options}
                    onChange={(event, element) => {
                      this.onUpdateValue({ keywordTarget: element.value });
                    }}
                  />}
                  labelPosition="left"
                >
                </Input>
              </div>
            </div>}
            </div>
            <div>
              <div className="ui grid">
                <div className="two column row">
                  <div className="six wide column">
                    <div className="item">
                      <div className="label">金額（月額使用料）</div>
                      <Dropdown
                        className="dropdownStyleBlock"
                        value={toInt(this.state.value.priceFrom)}
                        style={{ width: '100px' }}
                        key="0"
                        placeholder="指定なし"
                        options={masterData.priceNew.list}
                        inline
                        onChange={(event, element) => {
                          this.onUpdateValue({ priceFrom: element.value });
                        }}
                      />
                      円～
                      <Dropdown
                        className="dropdownStyleBlock"
                        value={toInt(this.state.value.priceTo)}
                        style={{ width: '100px' }}
                        key="0"
                        placeholder="指定なし"
                        options={masterData.priceNew.list.filter(option =>
                          !this.state.value.priceFrom || option.value > this.state.value.priceFrom || option.value === 0
                        )}
                        inline
                        onChange={(event, element) => {
                          this.onUpdateValue({ priceTo: element.value });
                        }}
                      />
                      円
                    </div>
                  </div>
                  <div className="six wide column">
                  <div className="item">
                    <div className="label">広さ</div>
                      <Dropdown
                        className="dropdownStyleBlock"
                        value={toInt(this.state.value.extentFrom)}
                        style={{ width: '100px' }}
                        key="0"
                        placeholder="指定なし"
                        options={masterData.extentNew.list}
                        inline
                        onChange={(event, element) => {
                          this.onUpdateValue({ extentFrom: element.value });
                        }}
                      />
                      帖～
                      <Dropdown
                        className="dropdownStyleBlock"
                        value={toInt(this.state.value.extentTo)}
                        style={{ width: '100px' }}
                        key="0"
                        placeholder="指定なし"
                        options={masterData.extentNew.list.filter(option =>
                          !this.state.value.extentFrom || option.value > this.state.value.extentFrom || option.value === 0
                        )}
                        inline
                        onChange={(event, element) => {
                          this.onUpdateValue({ extentTo: element.value });
                        }}
                      />
                      帖
                    </div>
                  </div>
                </div>
                <div className="two column row">
                  <div className="six wide column">
                    <div className="item">
                      <div className="label">階数</div>
                      <Dropdown
                        className="dropdownStyleBlock"
                        value={toInt(this.state.value.floor)}
                        style={{ width: '100px' }}
                        key="0"
                        placeholder="指定なし"
                        options={masterData.floorNew.list.filter(option =>
                          floorAvailableFlg || (!floorAvailableFlg && option.value <= 1)
                        )}
                        inline
                        onChange={(event, element) => {
                          this.onUpdateValue({ floor: element.value });
                        }}
                      />
                    </div>
                  </div>
                  <div className="ten wide column">
                    <div className="label" style={{ paddingBottom: '15px' }}>設備</div>
                    <div className="item widthLongButton">
                      <Facility
                        value={this.state.value.facility}
                        margin={{ top: 20 }}
                        onChangeValue={value =>
                          this.onUpdateValue({ facility: value })
                        }
                        setsubiAvailableFlg={setsubiAvailableFlg}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flexed_helper">
              <div className="btn" onClick={this.onSearch}>
                検索
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./pages/area/SearchCondition.jsx